__turbopack_context__.v({
  "container": "digitized-primary-source-viewer-module-scss-module__DzX-Kq__container",
  "hidden": "digitized-primary-source-viewer-module-scss-module__DzX-Kq__hidden",
  "viewerArea": "digitized-primary-source-viewer-module-scss-module__DzX-Kq__viewerArea",
  "viewerContainer": "digitized-primary-source-viewer-module-scss-module__DzX-Kq__viewerContainer",
});
